import styled from 'styled-components';

export const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    border-radius: 1.5rem;
    background-color: #0E2D11;
    padding: 15px 30px 10px 15px;
`;

export const StyledTitle = styled.h5`
    font-size: 12px;
    color: white;
    opacity: 0.5;
    margin: 0;
`;

export const StyledContent = styled.h5`
    font-size: 1.5rem;
    color: white;
    margin: 0;
    text-align: right;

    @media (max-width: 1100px) {
        font-size: 18px;
    }
`;